import React from "react";
import { Helmet } from "react-helmet";

const SITE_URL = "https://www.uvision.kz";
const SITE_NAME = "uVision Safety Solutions";
const DEFAULT_DESCRIPTION =
  "uVision Safety Solutions разрабатывает и внедряет инженерные решения для безопасности, мониторинга, позиционирования и автоматизации горных работ.";

function getAbsoluteUrl(path) {
  if (!path) {
    return SITE_URL;
  }

  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

function normalizeDescription(description) {
  if (!description) {
    return DEFAULT_DESCRIPTION;
  }

  return String(description).replace(/\s+/g, " ").trim().slice(0, 300);
}

export default function Seo({ title, description, path = "/", image, type = "website" }) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDescription = normalizeDescription(description);
  const canonical = getAbsoluteUrl(path);
  const absoluteImage = image ? getAbsoluteUrl(image) : undefined;

  return (
    <Helmet>
      <html lang="ru" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />
      {absoluteImage && <meta property="og:image" content={absoluteImage} />}
      <meta name="twitter:card" content={absoluteImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      {absoluteImage && <meta name="twitter:image" content={absoluteImage} />}
    </Helmet>
  );
}
